// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__ActionsCell__actions__QcTHJr{display:flex;flex-wrap:nowrap;gap:var(--JDS-DATA-TABLE-CELL-ITEM-GAP,4px)}", "",{"version":3,"sources":["webpack://./../../platform/@jutro/components/components/DataTable/components/DataTableCell/columns/ActionsCell.module.css"],"names":[],"mappings":"AAAA,mCACE,YAAA,CAEA,gBAAA,CADA,2CACA","sourcesContent":[".actions {\n  display: flex;\n  gap: var(--JDS-DATA-TABLE-CELL-ITEM-GAP, 4px);\n  flex-wrap: nowrap;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actions": "jut__ActionsCell__actions__QcTHJr"
};
export default ___CSS_LOADER_EXPORT___;
